export default "__VITE_ASSET__45cbj2RL__"